import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PatientService, UserService } from '../../shared';

@Component({
  selector: 'app-loginascarenavicator',
  templateUrl: './loginascarenavicator.component.html',
  styleUrls: ['./loginascarenavicator.component.css']
})
export class LoginascarenavicatorComponent implements OnInit {


  userName: string;
  userpass: string;
  strykerID: string;
  argnData: any;
  temPass: string;

  constructor(private patientservice: PatientService, private userService: UserService, private activatedRoute: ActivatedRoute) {

    this.activatedRoute.params
      .subscribe(data => {

        this.argnData = data;
        this.userName = this.argnData.uname;
        this.userpass = this.argnData.upass;
        this.strykerID = this.argnData.StrykerId;
      })

  }

  ngOnInit() {
    this.loginCareCoordinatorpage();
  }

  loginCareCoordinatorpage() {

    this.temPass = atob(this.userpass)
    window.localStorage['officeUser'] = this.strykerID
    const credentials = {
      'username': this.userName,
      'password': this.temPass,
      'captcha': '',
      'mode': '',
      'usermode': localStorage.getItem('userMode') ? atob(localStorage.getItem('userMode')) : 'c',
      'forcelogin': 'true',
      'officeUser':this.strykerID,
      'switchPortal':0    }

    this.userService
      .attemptPatientAuth(credentials, this.strykerID)
      .subscribe(
        data => {
          if (data) {
            window.localStorage['superClientId'] = 1
          }
        },
        err => {

        }
      );
  }

}
